import "./ServiceStructure.css"

const TitlePanel = props => {
  return (
    <div className="page-two-content">
      <div className="row d-md-flex justify-content-between align-items-center">
        <div className="col-md-9 text-white">
          <span className="span-title-three">{props.serviceType}</span>
          <div className="span-dub-two mb-3">
            <span></span>
          </div>
          <p className="department">
            <strong>{props.department}</strong>
          </p>
        </div>
      </div>
    </div>
  )
}

export default TitlePanel
